export const Slider = (props) => {
    return (
        <div id="slider">
            <div className="main-slider style1">
                <div className="slider-bg">
                    {/* optional content here */}
                </div>
            </div>
        </div>
    );
};
